/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type MassPaymentExportFormat = 'ABO' | 'ABOMONETA' | 'ABOWSBAG' | 'CFD' | 'CS' | 'GEMINI' | 'KM';

export const MassPaymentExportFormat = {
    ABO: 'ABO' as MassPaymentExportFormat,
    ABOMONETA: 'ABOMONETA' as MassPaymentExportFormat,
    ABOWSBAG: 'ABOWSBAG' as MassPaymentExportFormat,
    CFD: 'CFD' as MassPaymentExportFormat,
    CS: 'CS' as MassPaymentExportFormat,
    GEMINI: 'GEMINI' as MassPaymentExportFormat,
    KM: 'KM' as MassPaymentExportFormat
};

